/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';

const CpdsInputFieldsWrapper = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const applyStyleOverrides = props?.styleOverrides;
    return css`
    width: ${props.inputWidth || '50%'};
    &.invalid .text-field-wrapper,  &.invalid .text-select-wrapper {
      border-color: ${token?.input_fields_error_border_color || 'red'};
    }
    ${applyStyleOverrides}
  `}
  }
`;

const FlexRow = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CpdsLabelWrapper = styled.div`
  ${FlexRow}
  margin-bottom: 8px;
`;

const CpdsLabel = styled.label`
  ${({ theme: { styles: { cpds } }, isDisabled, themeColorMode, isOverRideTypography = false }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, themeColorMode);

    const labelStyles = isDisabled
      ? {
        fontSize: token?.input_fields_label_disable_font_size || '14px',
        fontWeight: token?.input_fields_label_disable_font_weight || '500',
        lineHeight: token?.input_fields_label_disable_line_height || '20px',
        color: token?.input_fields_label_disable_color || '#0C0E1C',
      }
      : {
        fontSize: token?.input_fields_label_font_size || '14px',
        fontWeight: token?.input_fields_label_font_weight || '500',
        lineHeight: token?.input_fields_label_line_height || '20px',
        color: token?.input_fields_label_color || '#0C0E1C',
      };

    return css`
      text-align: left;
      padding-right: 6px;
      & > p {
        ${isOverRideTypography && css`
          font-size: ${labelStyles.fontSize};
          font-weight: ${labelStyles.fontWeight};
          line-height: ${labelStyles.lineHeight};
          color: ${labelStyles.color};
      `}
      }
     
    `;
  }}
`;

const CpdsTextFieldWrapper = styled.div`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled } = props;
    const { borderType } = props;
    return css`
    height: 40px;
    border: 1px solid ${isDisabled ? token?.input_fields_disable_border_color : token?.input_fields_border_color || '#D1D5E2'};

    border-radius: ${borderType === 'RoundPill' ? '40px' : '8px'}; 

    background-color: white;
    ${FlexRow}
    justify-content: space-between;
    &.search {
      justify-content:flex-start;
    }
    padding: 0 17.33px 0 16px;
  `}
  }
`;

const CpdsTextField = styled.input`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled } = props;

    const inputStyles = isDisabled
      ? {
        fontSize: token?.input_fields_disable_font_size || '14px',
        fontWeight: token?.input_fields_disable_font_weight || '400',
        lineHeight: '16px',
        color: token?.input_fields_disable_font_color || '#0C0E1C',
        pHFontSize: token?.input_fields_placeholder_font_size || '14px',
        pHfontWeight: token?.input_fields_placeholder_font_weight || '400',
        pHlineHeight: token?.input_fields_placeholder_line_height || '16px',
        pHFontColor : token?.input_fields_placeholder_font_color || '#0C0E1C'
        

      }
      : {
        fontSize: token?.input_fields_font_size || '14px',
        fontWeight: token?.input_fields_font_weight || '400',
        lineHeight: '16px',
        color: token?.input_fields_font_color || '#0C0E1C',
        pHFontSize: token?.input_fields_placeholder_font_size || '14px',
        pHfontWeight: token?.input_fields_placeholder_font_weight || '400',
        pHlineHeight: token?.input_fields_placeholder_line_height || '16px',
        pHFontColor : token?.input_fields_placeholder_font_color || '#0C0E1C'
      };

    return css`
      height: 100%;
      background: transparent;
      padding-right: 15px;
      width: 100%;
      outline: none;
      cursor: text;
      color: ${inputStyles.color};
      font-size: ${inputStyles.fontSize};
      font-weight: ${inputStyles.fontWeight};
      line-height: ${inputStyles.lineHeight};
      &::placeholder {
        color: ${inputStyles.pHFontColor};
        font-size: ${inputStyles.pHFontSize};
        font-weight: ${inputStyles.pHfontWeight};
        line-height: ${inputStyles.pHlineHeight};
        opacity: 1;
      }
       
  `}
  }
`;

const CpdsSubmitWrapper = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
    ${FlexRow}
    justify-content: space-around;
    &.input-disable .input-submit-cta, &.input-disable .input-icon-submit {
      cursor: default;
    }
    :not(.input-disable):hover .input-submit-cta {
      color: ${token?.input_fields_submit_cta_focus_color || '#9CA0B0'};
    }
    :not(.input-disable):hover .input-icon-submit path {
      fill: ${token?.input_fields_submit_cta_focus_color || '#9CA0B0'};
    }
  `}
  }
`;

const CpdsInputCta = styled.button`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled, isFocused } = props;

    const buttonStyles = isDisabled
      ? {
        fontSize: token?.input_fields_disable_submit_cta_font_size || '14px',
        fontWeight: token?.input_fields_disable_submit_cta_font_weight || '400',
        lineHeight: '20px',
        color: token?.input_fields_disable_submit_cta_color || '#0C0E1C',
      }
      : {
        fontSize: token?.input_fields_submit_cta_font_size || '14px',
        fontWeight: token?.input_fields_submit_cta_font_weight || '400',
        lineHeight: '20px',
        color: isFocused ? token?.input_fields_submit_cta_focus_color : token?.input_fields_submit_cta_color || '#0C0E1C'
      };

    return css`
    height: 16px;
    width: auto;
    margin-right: 2px;
    background-color: transparent;
    font-size: ${buttonStyles.fontSize};
    font-weight: ${buttonStyles.fontWeight};
    lineHeight : ${buttonStyles.lineHeight};
    color: ${buttonStyles.color};
  `}
  }
`;

const CpdsHelperTextWrapper = styled.div`
  padding-top: 5px;
  ${FlexRow}
`;

const CpdsHelperLabel = styled.p`
  ${({ theme: { styles: { cpds } }, isDisabled, isOverRideTypography, isError, themeColorMode }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, themeColorMode);

    const labelStyles = isDisabled
      ? {
        fontSize: token?.input_fields_helper_label_disable_font_size || '14px',
        fontWeight: token?.input_fields_helper_label_disable_font_weight || '400',
        lineHeight: token?.input_fields_helper_label_disable_line_height || '20px',
        color: token?.input_fields_helper_label_disable_font_color || '#0C0E1C',
      }
      : {
        fontSize: token?.input_fields_helper_label_font_size || '14px',
        fontWeight: token?.input_fields_helper_label_font_weight || '400',
        lineHeight: token?.input_fields_helper_label_line_height || '20px',
        color: token?.input_fields_helper_label_color || '#0C0E1C',
      };

    const errorColor = token?.input_fields_error_label_color || '#C01E1E';

    return css`
      text-align: left;
      padding-left: 6px;
      color: ${isError ? errorColor : labelStyles.color}; 

      ${isOverRideTypography && css` && {
          font-size: ${labelStyles.fontSize};
          font-weight: ${labelStyles.fontWeight};
          line-height: ${labelStyles.lineHeight};
        }
      `}
    `;
  }}
`;

const CpdsSelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

const CpdsSelect = styled.select`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isError, borderType } = props;
    return css`
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-size: ${cpds?.input_fields_font_size || '14px'};
    font-weight: ${cpds?.input_fields_font_weight || '500'};
    text-align: left;
    color: ${cpds?.input_fields_font_color || 'black'};
    width: 100%;
    border: 1px solid ${isError ? token?.input_fields_error_border_color || 'red' : token?.input_fields_border_color || '#D1D5E2'};
    border-radius: ${borderType === 'RoundPill' ? '40px' : '8px'}; 
    background-color: white;
    padding: 12px 16px;
    padding-right: 40px;
    position: relative;
    &::-ms-expand {
      display: none;
    }
  `}
  }
`;

const Arrow = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isOpen } = props;
    return css`
    content: '';
    position: absolute;
    background-image: url("data:image/svg+xml,%0A%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.94 0.726685L4 3.78002L7.06 0.726685L8 1.66668L4 5.66668L0 1.66668L0.94 0.726685Z' fill='%230C0E1C'/%3E%3C/svg%3E%0A");
    top: 50%;
    right: 16px;
    width: 8px;
    height: 6px;
    transform: ${isOpen ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%) rotate(0deg)'};
    transition: transform 0.3s ease;
    pointer-events: none;
  `}
  }
`;

const CpdsCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: fit-content;
  flex-direction: column;
`;

const CpdsCheckboxWrapper = styled.div`
  display: flex;
  align-items: stretch;
  width: fit-content;
  
`;

const CpdsCheckbox = styled.input.attrs({ type: 'checkbox' })<{ checked: boolean; disabled: boolean; isError:boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    display: inline-block;
    background: transparent;
    border: 1px solid ${({ isError }) => (isError ? '#C01E1E' : '#818494')};
    -webkit-transition: all 150ms;
    transition: all 150ms;
    margin-top: 3px;
    &:before {
      background: transparent;
      content: "";
      width: 18px;
      height: 18px;
      position: absolute;
      border: 1px solid white;
      border-radius: 4px;
    }
    &:checked:before {
      background: ${({ checked }) => (checked ? '#1668E3' : 'transparent')};
    }
`;

const CpdsCheckboxLabel = styled.label<{ disabled: boolean }>`
  margin-left: 8px;
  letter-spacing: 0.13px;
  flex:1;
`;


export {
  CpdsInputFieldsWrapper,
  CpdsLabelWrapper,
  CpdsLabel,
  CpdsTextFieldWrapper,
  CpdsTextField,
  CpdsHelperTextWrapper,
  CpdsHelperLabel,
  CpdsInputCta,
  CpdsSubmitWrapper,
  CpdsSelect,
  CpdsSelectWrapper,
  Arrow,
  CpdsCheckboxContainer,
  CpdsCheckboxLabel,
  CpdsCheckbox,
  CpdsCheckboxWrapper
};
